/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */
export async function loadFonts() {
  const webFontLoader = await import(/* webpackChunkName: "webfontloader" */ 'webfontloader')
  webFontLoader.load({
    google: {
      families: [
        'DM Sans:400,500,600,700&display=swap',
        'Playfair Display:400,500,600,700&display=swap',
      ],
    },
  })
}
